import React, { useState } from "react";
import "../Styles/ContactInput.css";

const ContactInput = () => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidPhone = (value) => /^[6-9]\d{9}$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!phone) {
      setError("Phone number is required");
      return;
    }

    if (!isValidPhone(phone)) {
      setError("Enter a valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch("http://localhost:5000/request-call", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      if (!response.ok) throw new Error("Server error");

      setSuccess("We will call you shortly 👍");
      setPhone("");

      setTimeout(() => {
        setSuccess("");
      }, 5000);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="contact-input" onSubmit={handleSubmit} noValidate>
      <input
        type="tel"
        name="phone"
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
        className="contact-input-field"
        placeholder="Enter your Phone Number"
        value={phone}
        onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
        maxLength={10}
        inputMode="numeric"
      />

      <button type="submit" className="contact-input-button" disabled={loading}>
        {loading ? "Sending..." : "Submit"}
      </button>

      {error && <p className="error-text">{error}</p>}
      {success && <p className="success-text">{success}</p>}
    </form>
  );
};

export default ContactInput;
